import React, { useEffect, useState } from "react";
import { CloudRain } from "lucide-react";
import { api } from "@/lib/api";
import { inr } from "@/lib/format";

const ITEMS = [["today", "Today"], ["week", "This Week"], ["month", "This Month"], ["total", "All Time"]];

export const RainSummaryCard = ({ dpId }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/dp/${dpId}/rain-summary`).then(({ data }) => setS(data)).catch(() => {});
    load();
    window.addEventListener("ct-refresh", load);
    return () => window.removeEventListener("ct-refresh", load);
  }, [dpId]);
  if (!s) return null;
  return (
    <div className="mb-4 rounded-xl border border-border bg-card p-4" data-testid="dp-rain-summary">
      <p className="mb-3 flex items-center gap-2 text-sm font-semibold"><CloudRain className="h-4 w-4 text-sky-500" /> Rain Earnings</p>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {ITEMS.map(([k, l]) => (
          <div key={k} className="rounded-lg border border-border bg-background/50 p-3" data-testid={`dp-rain-${k}`}>
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground">{l}</p>
            <p className="mt-1 font-head text-lg font-bold tabular text-sky-500">{inr(s[k].earnings)}</p>
            <p className="text-xs text-muted-foreground">{s[k].orders} rain orders</p>
          </div>
        ))}
      </div>
    </div>
  );
};
